import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ImageWithLoadingComponent = ({
  src,
  alt = 'Image',
  className = '',
  fallbackSrc = '',
  hidden = false,
  onLoad,
  onError
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = (e) => {
    setLoading(false);
    if (onLoad) onLoad(e);
  };

  const handleError = (e) => {
    setLoading(false);
    setError(true);
    if (onError) onError(e);
  };

  return (
    <div className={`relative w-full h-full ${hidden ? 'd-none' : ''} ${className}`}>
      {/* Skeleton Loader (Shimmer Effect) */}
      {loading && !error && <div className="absolute inset-0 bg-gray-300 animate-pulse"></div>}

      {error ? (
        fallbackSrc ? (
          <img src={fallbackSrc} alt="Fallback" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-200 text-gray-500 text-sm">
            Image not available
          </div>
        )
      ) : (
        <img
          src={src}
          alt={alt}
          className={`w-full h-full object-cover ${loading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
          onLoad={handleLoad}
          onError={handleError}
        />
      )}
    </div>
  );
};

ImageWithLoadingComponent.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  fallbackSrc: PropTypes.string,
  hidden: PropTypes.bool,
  onLoad: PropTypes.func,
  onError: PropTypes.func
};

export default ImageWithLoadingComponent;
